import { useState, useRef, useEffect } from "react";
import { observer, inject } from "mobx-react";
import { Outlet } from "react-router-dom";
import { IconButton, Text } from "../UI";
import theme from "../UI/theme";
import SearchImg from "../asserts/img/search_white.svg";
import CloseImg from "../asserts/img/close_white.svg";
import ListImg from "../asserts/img/list_white.svg";
import ListUnSelectedImg from "../asserts/img/list_uneleced.svg";
import CalenderUnSelectedImg from "../asserts/img/calender_unselected.svg";
import CalenderImg from "../asserts/img/calender_white.svg";
import DrawerImg from "../asserts/img/drawer_white.svg";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import MobileDateRange from "../components/MobileDateRange";
import DateFilter from "../components/DateFilter";
import { publish } from "../utils/events";
import ecxel from "../asserts/img/ecxel.png";

const StyledInput = styled.input(() => ({
  fontSize: 18,
  backgroundColor: theme.color.blue,
  color: theme.color.white,
  border: "none",
  "::placeholder": {
    color: theme.color.white,
  },
  lineHeight: 1,
}));

const MobileHeader = ({
  title,
  handleDateChange,
  handleSearchChange,
  handleEcxelClick,
  search,
  date,
  setDate,
  setCalencderView,
  calencderView,
  children,
}) => {
  // Reopen the search bar when the page still has a search applied (e.g. after remounting)
  const [isSearch, setIsSearch] = useState(!!search);
  const [isDate, setIsDate] = useState(false);
  const { t } = useTranslation("common");
  const inputRef = useRef(null);

  useEffect(() => {
    if (isSearch) {
      inputRef.current?.focus();
    }
  }, [isSearch]);

  const handleMobileDateChange = (value) => {
    handleDateChange(value);
    setIsDate(false);
  };

  const showDrawer = () => {
    publish("showDrawer");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100vw",
          backgroundColor: theme.color.blue,
          padding: 10,
          gap: 24,
          paddingInline: 10,
          alignItems: "center",
        }}
      >
        {isSearch ? (
          <>
            <img src={SearchImg} alt="" style={{ width: 20, height: 20 }} />
            <StyledInput
              ref={inputRef}
              aria-label={t("search")}
              placeholder={t("search")}
              value={search ?? ""}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
            <IconButton
              src={CloseImg}
              label={t("close_search")}
              style={{ marginInlineStart: "auto" }}
              onClick={() => {
                setIsSearch(false);
                handleSearchChange("");
              }}
            />
          </>
        ) : (
          <>
            <IconButton src={DrawerImg} label={t("open_menu")} onClick={showDrawer} />
            <Text.H1 style={{ fontSize: 20 }} color={theme.color.white}>
              {title}
            </Text.H1>
            <div
              style={{
                marginInlineStart: "auto",
                display: "flex",
                flexDirection: "row",
                gap: 24,
                paddingInlineEnd: 10,
              }}
            >
              {!!handleDateChange && (
                <IconButton
                  src={CalenderImg}
                  label={t("filter_by_date")}
                  onClick={() => {
                    setIsSearch(false);
                    setIsDate(true);
                  }}
                />
              )}
              {!!handleSearchChange && (
                <IconButton
                  src={SearchImg}
                  label={t("open_search")}
                  onClick={() => {
                    setIsSearch(true);
                    setIsDate(false);
                  }}
                />
              )}
              {!!setCalencderView && (
                <>
                  <IconButton
                    src={!!calencderView ? ListUnSelectedImg : ListImg}
                    label={t("list_view")}
                    aria-pressed={!calencderView}
                    onClick={() => {
                      setCalencderView(false);
                    }}
                  />
                  <IconButton
                    src={!!calencderView ? CalenderImg : CalenderUnSelectedImg}
                    label={t("calendar_view")}
                    aria-pressed={!!calencderView}
                    onClick={() => {
                      setCalencderView(true);
                    }}
                  />
                </>
              )}
              {!!handleEcxelClick && (
                <IconButton
                  src={ecxel}
                  label={t("export_to_excel")}
                  iconSize={25}
                  style={{ alignSelf: "center" }}
                  onClick={handleEcxelClick}
                />
              )}
            </div>
          </>
        )}
      </div>
      {!!isDate ? (
        <>
          <MobileDateRange
            date={date}
            setIsDate={setIsDate}
            handleDateChange={handleMobileDateChange}
          />
        </>
      ) : (
        <>
          <DateFilter date={date} setDate={setDate} />
          {children}
          <Outlet />
        </>
      )}
    </div>
  );
};

export default inject()(observer(MobileHeader));
